import Keycloak from 'keycloak-js';
import { auth } from './auth';

const keycloak = new Keycloak(auth);

export default keycloak;
